import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Contract } from '@classes/contract';
import { ContractService } from 'app/core/services/contract.service';
import { AutocompleteObjectValidator } from '@shared/validators/autocomplete-object-validator';
import { ContractType } from '@classes/contract-type';
import { ContractType as ContractTypeEnum, NameToContractType } from '@enums/contract-type.enum';
import { UiService } from 'app/core/services/ui.service';


@Component({
  selector: 'app-contract-creation',
  templateUrl: './contract-creation.component.html',
  styleUrls: ['./contract-creation.component.scss']
})
export class ContractCreationComponent implements OnInit {

  contractTypes: ContractType[] = [];
  selectedContractType: ContractTypeEnum | undefined;
  ContractType = ContractTypeEnum;
  contractForm: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private autocompleteObjectValidator: AutocompleteObjectValidator,
    private contractService: ContractService,
    private uiService: UiService,
    @Optional() public dialogRef: MatDialogRef<ContractCreationComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: Contract
  ) { }

  ngOnInit() {
    this.initFormBuilder(this.data);
    this.contractService.getContractType().subscribe(values => {
      const orderList = [
        ContractTypeEnum.termConcession,
        ContractTypeEnum.precariousConcession,
        ContractTypeEnum.publicDock,
      ]
      this.contractTypes = values
        .sort((a, b) => (NameToContractType.get(a?.name || "") || 0) > (NameToContractType.get(b?.name || "") || 0)
          ? 1
          : (NameToContractType.get(b?.name || "") || 0) > (NameToContractType.get(a?.name || "") || 0) ? -1 : 0);
    })
  }

  private initFormBuilder(value?: Contract) {
    const fb = this.formBuilder;
    const disabled = false;
    this.contractForm = fb.group({
      id: fb.control(value?.id),
      company: fb.control({ value: value?.company, disabled: false }, []),
      site: fb.control({ value: value?.site, disabled: false }, [Validators.required, this.autocompleteObjectValidator.autocompleteObjectValidator()]),
      contractTypeId: fb.control({ value: value?.contractType, disabled: disabled }, [Validators.required]),
      // zone: fb.control({ value: value?.zone, disabled: disabled }, [Validators.required]),
      // isFittedOutArea: fb.control({ value: value?.isFittedOutArea, disabled: disabled }, []),
      // isGoodAccessibility: fb.control({ value: value?.isGoodAccessibility, disabled: disabled }, []),
      isPunctualHandling: fb.control({ value: value?.isPunctualHandling, disabled: disabled }, []),
      dateBegin: fb.control({ value: value?.dateBegin, disabled: disabled }, []),
      dateEnd: fb.control({ value: value?.dateEnd, disabled: disabled }, []),
      quantityMin: fb.control({ value: value?.quantityMin, disabled: disabled }, [Validators.required]),
    });

    this.contractForm.controls.contractTypeId.valueChanges.subscribe(value => {
      const contractType = this.contractTypes.find(f => f.id == value);
      this.selectedContractType = NameToContractType.get(contractType?.name || "")

      // this.contractForm.controls.zone.setValue(null);
      // this.contractForm.controls.zone.setValidators([]);
      // this.contractForm.controls.isFittedOutArea.setValue(null);
      // this.contractForm.controls.isFittedOutArea.setValidators([]);
      // this.contractForm.controls.isGoodAccessibility.setValue(null);
      // this.contractForm.controls.isGoodAccessibility.setValidators([]);
      this.contractForm.controls.isPunctualHandling.setValue(null);
      this.contractForm.controls.isPunctualHandling.setValidators([]);

      switch (this.selectedContractType) {
        // case ContractTypeEnum.termConcession:
        //   this.contractForm.controls.zone.setValidators([Validators.required]);
        //   this.contractForm.controls.isFittedOutArea.setValidators([Validators.required]);
        //   this.contractForm.controls.isGoodAccessibility.setValidators([Validators.required]);
        //   break;
        // case ContractTypeEnum.precariousConcession:
        //   this.contractForm.controls.zone.setValidators([Validators.required]);
        //   this.contractForm.controls.isFittedOutArea.setValidators([Validators.required]);
        //   this.contractForm.controls.isGoodAccessibility.setValidators([Validators.required]);
        //   break;
        case ContractTypeEnum.publicDock: {
          this.contractForm.controls.isPunctualHandling.setValidators([Validators.required]);
          break;
        }
      };

      // this.contractForm.controls.zone.updateValueAndValidity();
      // this.contractForm.controls.isFittedOutArea.updateValueAndValidity();
      // this.contractForm.controls.isGoodAccessibility.updateValueAndValidity();
      this.contractForm.controls.isPunctualHandling.updateValueAndValidity();

    });

    this.contractForm.controls.isPunctualHandling.valueChanges.subscribe(value => {
      this.contractForm.controls.quantityMin.setValidators([Validators.required]);
      // this.contractForm.controls.dateBegin.setValidators([Validators.required]);
      // this.contractForm.controls.dateEnd.setValidators([Validators.required]);
      if (value != null && value == 'true') {
        this.contractForm.controls.quantityMin.setValue(null);
        this.contractForm.controls.quantityMin.setValidators([]);
        // this.contractForm.controls.dateBegin.setValue(null);
        // this.contractForm.controls.dateBegin.setValidators([]);
        // this.contractForm.controls.dateEnd.setValue(null);
        // this.contractForm.controls.dateEnd.setValidators([]);
      }
      this.contractForm.controls.quantityMin.updateValueAndValidity();
      // this.contractForm.controls.dateBegin.updateValueAndValidity();
      // this.contractForm.controls.dateEnd.updateValueAndValidity();
    });
  }

  onSubmit() {
    this.uiService.addRouteLoading();
    let contract = new Contract(this.contractForm.value);

    this.contractService.createNewContract(contract).subscribe(data => {
      this.dialogRef.close(true)
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }

  onCancel() {
    this.dialogRef.close(false);
  }

}
